import { put, takeLatest } from "redux-saga/effects";
import { requestCenterAreaDueDetailsList } from "services/acclgl/reports/centerAreaDueDetails";
import {
    fetchCenterAreaDueDetailsListRequest,
  fetchCenterAreaDueDetailsListSuccess,
  fetchCenterAreaDueDetailsListFailure,
} from "redux/reducers/acclgl/reports/centerAreaDueDetails";
export function* watchCenterAreaDueDetailsSaga() {
  yield takeLatest(fetchCenterAreaDueDetailsListRequest, fetchCenterAreaDueDetailsList);
}

function* fetchCenterAreaDueDetailsList({ payload }) {
  try {
    const response = yield requestCenterAreaDueDetailsList(payload);
    yield put(fetchCenterAreaDueDetailsListSuccess(response));
  } catch (error) {
    yield put(
        fetchCenterAreaDueDetailsListFailure("Failed to get list of CenterAreaDueDetails List")
    );
  }
}
